import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './components/store/store';   // fixed relative path
import { gaPageView } from './analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// Send initial page_view after first paint
gaPageView(window.location.pathname + window.location.search);

reportWebVitals();
